import { useMemo } from "react";
import { BulkGeneration, type BulkSessionStore } from "@proof/authoring";
import { bulkGenerationServices } from "@proof/sdk";
import type { Project } from "@proof/core";
import { useWorkspaceTransport } from "./WorkspaceContext";
const demoProfiles = [
  { id: "alex", label: "Alex Morgan" },
  { id: "jamie", label: "Jamie Rivera" },
  { id: "guest", label: "Guest" },
];
export function Bulk({
  project,
  versionId,
  notify,
}: {
  project: Project;
  versionId?: string;
  notify(message: string): void;
}) {
  const transport = useWorkspaceTransport();
  const services = useMemo(
    () =>
      bulkGenerationServices(transport.client, {
        mode: transport.demo ? "demo" : "published",
      }),
    [transport.client, transport.demo],
  );
  const session = useMemo<BulkSessionStore | undefined>(
    () =>
      transport.demo
        ? {
            read: () =>
              JSON.parse(
                localStorage.getItem(`proof-studio-bulk-${project.id}`) ||
                  "null",
              ),
            write: (value) =>
              localStorage.setItem(
                `proof-studio-bulk-${project.id}`,
                JSON.stringify(value),
              ),
          }
        : undefined,
    [transport.demo, project.tenantId, project.id],
  );
  return (
    <BulkGeneration
      project={project}
      versionId={versionId}
      services={services}
      proofServices={transport.proofServices}
      contextProfiles={transport.demo ? demoProfiles : undefined}
      session={session}
      notify={notify}
      showNotices={false}
    />
  );
}
